import {
  Component,
  Inject,
  ViewChild,
  AfterViewInit,
  OnInit,
} from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { KeySlService } from 'src/app/services/key-sl.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { v4 as uuidv4 } from 'uuid';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
@Component({
  selector: 'app-select-api-sl',
  templateUrl: './select-api-sl.component.html',
  styleUrls: ['./select-api-sl.component.scss'],
})
export class SelectApiSlComponent implements AfterViewInit, OnInit {
  displayedColumns: string[] = ['select', 'name', 'phone']; // Ajusta según los datos de la API
  dataSource = new MatTableDataSource<any>([]);

  selection = new SelectionModel<any>(true, []); // Para manejar la selección de filas
  tableResult: boolean;
  aviableApis = [];
  keysEntities: string[] = [];
  apiSelected;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private keySlService: KeySlService,
    public dialogRef: MatDialogRef<SelectApiSlComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {
    if (this.data.category) {
      this.getApiSocialLinkByCategory(this.data.category);
    } else {
      this.getApisSl();
    }
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator; // Asigna el paginador después de que la vista se haya inicializado
  }

  async getApisSl() {
    this.keySlService.getApiSocialLinkActive().subscribe({
      next: (aviableApis: any) => {
        this.aviableApis = aviableApis;
      },
    });
  }

  async getApiSocialLinkByCategory(category: string) {
    this.keySlService.getApiSocialLinkByCategory(category).subscribe({
      next: (aviableApis: any) => {
        this.aviableApis = aviableApis;
      },
    });
  }
  noDAta: boolean;
  setTableResult(data: any) {
    if (
      data.entities.results?.length === 0 ||
      data.entities.result?.length === 0
    )
      this.noDAta = true;
    let entitiesResult = data.entities;
    this.apiSelected = data.apiSelect;
    console.log(entitiesResult, this.apiSelected, this.data);

    if (entitiesResult.results) {
      // Verifica si hay resultados en `results` o `result`
      if (entitiesResult.results[0]) {
        this.keysEntities = Object.keys(entitiesResult.results[0]);
        this.displayedColumns = ['select', ...this.keysEntities];
        this.dataSource.data = entitiesResult.results.flatMap((entitie) =>
          this.formatEntity(entitie)
        );
      }
    }
    if (entitiesResult.result) {
      if (entitiesResult.result[0]) {
        this.keysEntities = Object.keys(entitiesResult.result[0]);
        this.displayedColumns = ['select', ...this.keysEntities];
        this.dataSource.data = entitiesResult.result.flatMap((entitie) =>
          this.formatEntity(entitie)
        );
      }
    }

    this.dataSource.paginator = this.paginator;
    this.tableResult = true;
  }

  formatEntity(entity: any): any {
    const formattedEntity: any = {};

    // Si la entidad es nula, indefinida o un objeto vacío, retorna un objeto con 'no data'
    if (!entity || Object.keys(entity).length === 0) {
      const emptyEntity: any = {};
      for (const key of this.keysEntities) {
        emptyEntity[key] = 'no data'; // Asigna 'no data' a todas las propiedades
      }
      return emptyEntity;
    }

    // Recorre cada propiedad de la entidad
    for (const key in entity) {
      if (entity.hasOwnProperty(key)) {
        const value = entity[key];

        // Si el valor es nulo, indefinido, un objeto vacío o un array vacío, asigna 'no data'
        if (
          value === null ||
          value === undefined ||
          (typeof value === 'object' && Object.keys(value).length === 0) || // Objeto vacío
          (Array.isArray(value) && value.length === 0) // Array vacío
        ) {
          formattedEntity[key] = 'no data';
        } else if (Array.isArray(value)) {
          // Si es un array, lo convierte en un string clave-valor
          formattedEntity[key] = this.formatArray(value);
        } else if (typeof value === 'object') {
          // Si es un objeto no vacío, lo convierte en un string clave-valor
          formattedEntity[key] = this.formatObject(value);
        } else {
          // Si no es un array ni un objeto, lo copia tal cual
          formattedEntity[key] = value;
        }
      }
    }

    return formattedEntity;
  }

  // Función para formatear un array de objetos a string clave-valor
  formatArray(array: any[]): string {
    return array
      .map((item) => {
        // Convierte cada objeto en un string clave-valor
        return Object.entries(item)
          .map(([key, value]) => `${key}: ${value}`)
          .join(', ');
      })
      .join('; '); // Separa cada objeto con un punto y coma
  }

  // Función para formatear un objeto a string clave-valor
  formatObject(obj: any): string {
    return Object.entries(obj)
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
  }

  // Seleccionar/deseleccionar todas las filas
  toggleAll() {
    if (this.selection.selected.length === this.dataSource.data.length) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach((row) => this.selection.select(row));
    }
  }

  // Seleccionar/deseleccionar una fila
  toggleSelection(row: any) {
    this.selection.toggle(row);
  }

  // Crear entidades seleccionadas en Neo4j
  async createSelectedEntities() {
    const selectedRows = this.selection.selected;
    console.log(selectedRows);

    try {
      // Obtener información del nodo seleccionado
      const selectedNode = this.data.node; // Asume que el nodo seleccionado está en this.data.node
      const selectedNodeId = selectedNode.raw.properties.id; // ID del nodo seleccionado
      const selectedNodeLabel = selectedNode.raw.labels[0]; // Etiqueta del nodo seleccionado (por ejemplo, "Customer")
      // const dynamicLabel = this.apiSelected.descripcion;
      const dynamicLabel = this.apiSelected.nodeType;
      for (const row of selectedRows) {
        const uniqueId = uuidv4();

        const params = {
          properties: {
            ...row,
            id: uniqueId,
          },
        };

        // Crear nodo y relación con etiqueta dinámica
        await this.keySlService.updateGraphWithDynamicLabel(
          selectedNodeLabel,
          dynamicLabel,
          selectedNodeId,
          params
        );
      }
      this.keySlService.triggerGraphUpdate(
        selectedNodeId,
        this.apiSelected.nodeType,
        selectedNodeLabel
      );
      // Actualizar el grafo
      this.keySlService.updateGraph();
      this.dialogRef.close();
    } catch (error) {
      console.error('Error al crear entidades seleccionadas:', error);
    }
  }

  close() {
    this.dialogRef.close();
  }
}
